import { render, staticRenderFns } from "./printSmallPayFeeList.vue?vue&type=template&id=fb4baa4a&scoped=true"
import script from "./printSmallPayFeeList.vue?vue&type=script&lang=js"
export * from "./printSmallPayFeeList.vue?vue&type=script&lang=js"
import style0 from "./printSmallPayFeeList.vue?vue&type=style&index=0&id=fb4baa4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4baa4a",
  null
  
)

export default component.exports